import React from 'react'
import { WebsiteLayout } from '../components/common/layout';
import { AppScreen } from '../components/screens';
import { useEffect, useState } from 'react';

const getOS = (userAgent) => {
  const osArray = [
    { regex: /windows nt 6.2/i, value: 'Windows 8' },
    { regex: /windows nt 6.1/i, value: 'Windows 7' },
    { regex: /windows nt 6.0/i, value: 'Windows Vista' },
    { regex: /windows nt 5.2/i, value: 'Windows Server 2003/XP x64' },
    { regex: /windows nt 5.1/i, value: 'Windows XP' },
    { regex: /windows xp/i, value: 'Windows XP' },
    { regex: /windows nt 5.0/i, value: 'Windows 2000' },
    { regex: /windows me/i, value: 'Windows ME' },
    { regex: /win98/i, value: 'Windows 98' },
    { regex: /win95/i, value: 'Windows 95' },
    { regex: /win16/i, value: 'Windows 3.11' },
    { regex: /macintosh|mac os x/i, value: 'Mac OS X' },
    { regex: /mac_powerpc/i, value: 'Mac OS 9' },
    { regex: /linux/i, value: 'Linux' },
    { regex: /ubuntu/i, value: 'Ubuntu' },
    { regex: /iphone/i, value: 'iPhone' },
    { regex: /ipod/i, value: 'iPod' },
    { regex: /ipad/i, value: 'iPad' },
    { regex: /android/i, value: 'Android' },
    { regex: /blackberry/i, value: 'BlackBerry' },
    { regex: /webos/i, value: 'Mobile' },
  ];

  let osPlatform = 'Unknown OS Platform';

  osArray.forEach(({ regex, value }) => {
    if (regex.test(userAgent)) {
      osPlatform = value;
    }
  });

  return osPlatform;
};

const App = ({ logout, user }) => {

  //const [osPlatform, setOSPlatform] = useState('Unknown OS Platform');
  
  useEffect(() => {
    const userAgent = navigator.userAgent;
    const os = getOS(userAgent);
    //setOSPlatform(detectedOS);
    if (os == 'iPhone' || os == 'iPod' || os == 'iPad')
      window.location.href = 'https://itunes.apple.com/app/expresspay/id755749885?mt=8';
    else if (os == 'Android')
      window.location.href = 'https://play.google.com/store/apps/details?id=com.expresspay'
    else if (os == 'BlackBerry')
      window.location.href = 'https://appworld.blackberry.com/webstore/content/52277890/?countrycode=US&lang=en'
  }, []);


  
  return (
    <>
       <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
        <AppScreen />
      </WebsiteLayout>
    </>
  )
}

export default App